
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/pasm-project-tracking",
      function () {
        return require("private-next-pages/solutions/pasm-project-tracking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/pasm-project-tracking"])
      });
    }
  